<template lang="pug">
  .main-dicom-params
    div
      v-card(v-observe-visibility="visibilityChanged")
        v-card-title
          span(v-if="!selected") Nenhum item selecionado
          div(v-else)
            v-chip(
              v-for="item in selectedItems"
              :key="selected.param"
              v-model="item.active"
              @input="selectedItems.push()"
              close
              )
              | {{ item.group }} | {{ item.param }} | {{ item.author }} | {{ item.unit }}
          v-spacer
          v-text-field.ma-0.pa-0(
            v-model="table.search"
            label="procurar"
            append-icon="search"
            single-line
            hide-details)
        v-card-text.pa-0
          v-data-table(
            :headers='table.headers'
            :items='items'
            :search='table.search')
            template(v-slot:items='props')
              tr(@click="addSelected(props.item)")
                td {{ props.item.device }}
                td {{ props.item.group }}
                td {{ props.item.param }}
                td {{ props.item.author }}
                td {{ props.item.value }} {{ props.item.unit }}
        v-divider
        v-card-actions
          v-btn(flat @click='clearPreset') limpar
          v-spacer
          v-btn(flat @click="$emit('close', true)") cancelar
          v-btn(color='primary' @click='savePreset') salvar
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { db } from '@/store/firebase'

export default {
  name: 'btn-dicom-params',

  props: {
    field: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState({
      dicomParams: state => state.ultraFetal.dicomDeviceParams,
      dicomForms: state => state.ultraFetal.dicomForms,
      company: state => state.ultraFetal.company
    }),
    items () {
      if (this.dicomParams) {
        let params = Object.keys(this.dicomParams).reduce((acc, device) => {
          return acc.concat(this.dicomParams[device].map(item => {
            return ({device, ...item})
          }))
        }, [])
        const m = /_(\d+)/.exec(this.field)
        let fetus
        fetus = m ? m[1] : '1'
        params = params.filter(param => param['fetus'] === fetus)
        return params
      }
      return []
    },
    fieldFormated () {
      return this.field.replace(/_(\d+)/g, '$')
    }
  },

  watch: {
    field (val) {
      if (val) this.findPreset()
    }
  },

  data () {
    return {
      selected: null,
      selectedItems: [],
      table: {
        search: '',
        headers: [
          { text: 'Equip.', value: 'device' },
          { text: 'Grupo', value: 'group' },
          { text: 'Nome', value: 'param' },
          { text: 'Autor', value: 'author' },
          { text: 'Valor', value: 'value' }
        ]
      }
    }
  },

  methods: {
    async clearPreset () {
      try {
        const { fieldFormated, company, selected } = this
        if (!selected) {
          return
        }
        let payload = {}
        payload[selected.device] = {}
        payload[selected.device][fieldFormated] = null
        this.selectedItems = []
        await db.doc(`dicomForms/${company.iuid}`).set(payload, {merge: true})
        console.log('SAVE DICOM FORMS')
        this.selected = null
        this.$store.dispatch('ultraFetal/getDicomForms')
      } catch (e) {
        console.error(e)
      }
    },
    async savePreset () {
      try {
        const { fieldFormated, company, selected, selectedItems } = this
        if (!selected || !selectedItems) return
        let payload = {}
        payload[selected.device] = {}
        const items = this.selectedItems.filter(item => item.active).map(item => ({
          group: _.get(item, 'group', null),
          author: _.get(item, 'author', null),
          param: _.get(item, 'param', null),
          unit: _.get(item, 'unit', null)
        }))
        payload[selected.device][fieldFormated] = items
        await db.doc(`dicomForms/${company.iuid}`).set(payload, {merge: true})
        console.log('SAVE DICOM FORMS')
        this.$store.dispatch('ultraFetal/getDicomForms')
        this.$emit('close', true)
      } catch (e) {
        console.error(e)
      }
    },
    async findPreset () {
      const { fieldFormated, dicomParams, dicomForms } = this
      if (dicomForms && dicomParams) {
        let device = Object.keys(dicomParams)[0]

        for (let i = 0; i < dicomParams.length; i++) {
          if (dicomParams[i]['ManufacturerModelName']) {
            device = dicomParams[i]['ManufacturerModelName']
            break
          }
        }
        if (!device) return
        const dataItem = dicomForms[device]
        console.log(dataItem, fieldFormated)
        if (dataItem) {
          const dataItemField = dataItem[fieldFormated]
          console.log(dataItemField)
          if (dataItemField) {
            let items = Array.isArray(dataItemField) ? dataItemField : [dataItemField]
            for (let item of items) {
              item.active = true
            }
            this.selected = { device }
            this.selectedItems = items
          }
        }
      }
    },
    addSelected (item) {
      if (item.active) return
      item.active = true
      if (!this.selected) {
        this.selected = { device: item.device }
        this.selectedItems = [item]
      } else {
        const items = this.selectedItems
        if (items && Array.isArray(items)) {
          items.push(item)
        } else {
          this.selectedItems = [item]
        }
      }
    },

    visibilityChanged (isVisible) {
      if (isVisible) {
        this.findPreset()
      }
    }
  }
}
</script>

<style lang='stylus' scoped>
.main-dicom-params1
  position absolute
  top 0
  right 0
</style>



// WEBPACK FOOTER //
// src/components/form/buttons/DicomParams.vue